/* theme.js — Elipa Deco Shopify theme: AJAX cart drawer, product cards, hero "coulée",
 * product variant picker, collection tools. Re-initialises sections reloaded in the theme editor. */
(function () {
  "use strict";
  var doc = document, T = window.theme || {}, S = T.strings || {};
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || "{{amount}} DH";
    function f(n, d, ts, ds) { var p = (n / 100).toFixed(d).split("."); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p[0] + (p[1] ? ds + p[1] : ""); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === "amount_no_decimals") return f(cents, 0, ",", ".");
      if (k === "amount_with_comma_separator") return f(cents, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return f(cents, 0, ".", ",");
      if (k === "amount_with_space_separator") return f(cents, 2, " ", ",");
      return f(cents, 2, ",", ".");
    }).replace(/<[^>]+>/g, "");
  }

  /* =================== CART =================== */
  var R = T.routes || {}, cartState = null;
  function api(url, body) {
    return fetch(url, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function img(url, w) { if (!url) return ""; return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 160); }

  function renderCart(c, bump) {
    cartState = c;
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = c.item_count; el.hidden = !c.item_count;
      if (bump) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
    });
    $$("[data-cart-total]").forEach(function (el) { el.textContent = money(c.total_price); });
    $$("[data-cart-hide-empty]").forEach(function (el) { el.hidden = !c.item_count; });
    $$("[data-cart-show-empty]").forEach(function (el) { el.hidden = !!c.item_count; });
    $$("[data-cart-items]").forEach(function (box) {
      box.innerHTML = c.items.length ? c.items.map(function (it) {
        var vt = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
        return '<div class="ci"><a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 180)) + '" alt="" width="72" height="72" loading="lazy"></a><div><b>' + esc(it.product_title) + "</b>" +
          (vt ? "<small>" + esc(vt) + "</small>" : "") + '<span class="lp">' + money(it.final_line_price) + "</span></div>" +
          '<div class="qty"><button type="button" data-qty-key="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="-">−</button><span>' + it.quantity +
          '</span><button type="button" data-qty-key="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div></div>';
      }).join("") : '<div class="empty">' + "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\"><path d=\"M6 7h12l-1 13H7L6 7Z\"/><path d=\"M9 7a3 3 0 0 1 6 0\"/></svg><p>" + esc(S.empty) + "</p></div>";
    });
  }
  function refreshCart(bump) { return api(R.cartJs).then(function (c) { renderCart(c, bump); return c; }); }

  function setOpen(open) {
    doc.body.classList.toggle("cart-open", open);
    if (open && toastEl) toastEl.classList.remove("show");
    var d = $("[data-cart-drawer]");
    if (d) { d.setAttribute("aria-hidden", open ? "false" : "true"); if (open) setTimeout(function () { var c = $("[data-cart-close].icon-btn", d); if (c) c.focus(); }, 60); }
  }

  function fly(from) {
    var target = $$("[data-cart-open]").filter(function (b) { return b.offsetParent; })[0];
    if (!from || !target || reduce) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect(); if (!a.width) return;
    var g = from.cloneNode(); g.removeAttribute("srcset"); g.removeAttribute("sizes"); g.className = "";
    g.style.cssText = "position:fixed;z-index:999;pointer-events:none;border-radius:20px;object-fit:cover;left:" + a.left + "px;top:" + a.top + "px;width:" + a.width + "px;height:" + a.height + "px;transition:transform .85s cubic-bezier(.5,-0.2,.3,1),opacity .85s,border-radius .85s";
    doc.body.appendChild(g);
    requestAnimationFrame(function () {
      g.style.transform = "translate(" + (b.left + b.width / 2 - a.left - a.width / 2) + "px," + (b.top + b.height / 2 - a.top - a.height / 2) + "px) scale(.08)";
      g.style.opacity = ".5"; g.style.borderRadius = "50%";
    });
    setTimeout(function () { g.remove(); }, 900);
  }
  var toastEl, toastT;
  function toast(item) {
    if (!toastEl) { toastEl = doc.createElement("div"); toastEl.className = "toast"; toastEl.setAttribute("role", "status"); doc.body.appendChild(toastEl); }
    var vt = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    toastEl.innerHTML = '<img src="' + esc(img(item.image, 120)) + '" alt=""><div><b>' + esc(item.product_title) + " — " + esc(S.added) + "</b><small>" + esc(vt) + '</small></div><button type="button" data-cart-open>' + esc(S.viewCart) + "</button>";
    requestAnimationFrame(function () { toastEl.classList.add("show"); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("show"); }, 3200);
  }
  function addToCart(id, qty, srcImg, then) {
    return api(R.cartAdd, { items: [{ id: +id, quantity: qty || 1 }] }).then(function (res) {
      var item = res.items ? res.items[0] : res;
      if (then === "checkout") { location.href = "/checkout"; return; }
      fly(srcImg); toast(item); refreshCart(true);
      if (window.fbq) fbq("track", "AddToCart", { content_ids: [String(id)], content_type: "product" });
    }).catch(function (e) { alert((e && (e.description || e.message)) || S.unavailable); });
  }

  doc.addEventListener("click", function (e) {
    var t = e.target.closest("[data-add],[data-qty-key],[data-cart-open],[data-cart-close]"); if (!t) return;
    if (t.hasAttribute("data-add")) {
      e.preventDefault(); if (t.disabled) return;
      addToCart(t.getAttribute("data-add"), +t.getAttribute("data-qty") || 1, $(".media img:not(.alt)", t.closest(".pc") || doc));
    } else if (t.hasAttribute("data-qty-key")) {
      api(R.cartChange, { id: t.getAttribute("data-qty-key"), quantity: Math.max(0, +t.getAttribute("data-q")) }).then(function (c) {
        renderCart(c, true);
        if (doc.body.classList.contains("template-cart")) location.reload();
      });
    } else if (t.hasAttribute("data-cart-open")) {
      if (doc.body.classList.contains("template-cart")) return; // already on the cart page
      e.preventDefault(); setOpen(true); refreshCart(false);
    } else { setOpen(false); }
  });
  addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false); });

  // product forms: add with AJAX (buy-now button goes straight to checkout)
  doc.addEventListener("submit", function (e) {
    var f = e.target; if (!f.matches || !f.matches("form[data-product-form]")) return;
    e.preventDefault();
    var sub = e.submitter, id = f.elements.id.value, q = +(f.elements.quantity || { value: 1 }).value || 1;
    if (sub && sub.disabled) return;
    addToCart(id, q, $(".pp-main img:last-of-type"), sub && sub.hasAttribute("data-buy-now") ? "checkout" : null);
  });
  refreshCart(false).catch(function () {});

  /* =================== COMPONENTS (re-run per section in the editor) =================== */
  function initCards(root) {
    $$(".pc .dots", root).forEach(function (dots) {
      if (dots._init) return; dots._init = true;
      dots.addEventListener("click", function (e) {
        var d = e.target.closest("button"); if (!d) return;
        var pc = d.closest(".pc"), ok = d.getAttribute("data-ok") === "true";
        $$("button", dots).forEach(function (b) { b.classList.toggle("on", b === d); });
        var im = $(".media img:not(.alt)", pc), src = d.getAttribute("data-img");
        if (im && src) { im.removeAttribute("srcset"); im.src = src; }
        $$("[data-add]", pc).forEach(function (b) {
          b.setAttribute("data-add", d.getAttribute("data-variant")); b.disabled = !ok;
          b.innerHTML = ok ? (b.classList.contains("add-m") ? S.add : S.addToCart) : S.colorSoldOut;
        });
      });
    });
  }

  function initPour(root) {
    $$("[data-pour]", root).forEach(function (box) {
      if (box._init) return; box._init = true;
      var data; try { data = JSON.parse($("script[type='application/json']", box).textContent); } catch (e) { return; }
      var vs = data.filter(function (v) { return v.img; }); if (vs.length < 2) return;
      var arch = $(".arch", box), swBox = $(".swatches", box), name = $("[data-pour-color]", box), tag = $(".pour-tag", box);
      var idx = +box.getAttribute("data-start-index") || 0, busy = false, hover = false, visible = true, held = 0;
      vs.forEach(function (v) { var i = new Image(); i.src = v.img; });
      function set(i, user) {
        if (i === idx || busy) return;
        var v = vs[i]; idx = i; busy = true;
        $$(".sw", swBox).forEach(function (b, k) { b.setAttribute("aria-checked", k === i ? "true" : "false"); });
        var b = $$(".sw", swBox)[i]; b.classList.remove("ripple"); void b.offsetWidth; b.classList.add("ripple");
        box.style.setProperty("--tint", v.sw); if (name) name.textContent = v.c; if (tag && v.url) tag.href = v.url;
        var old = $$("img", arch), im = new Image();
        im.src = v.img; im.alt = v.alt || ""; im.className = "pour-in"; arch.appendChild(im);
        var finish = function () { old.forEach(function (o) { o.remove(); }); im.className = ""; busy = false; };
        if (reduce) return finish();
        requestAnimationFrame(function () { requestAnimationFrame(function () { im.classList.add("go"); }); });
        setTimeout(finish, 1250);
        if (user) held = Date.now();
      }
      swBox.addEventListener("click", function (e) { var b = e.target.closest(".sw"); if (b) set(+b.getAttribute("data-i"), true); });
      swBox.addEventListener("keydown", function (e) {
        if (!/Arrow(Left|Right)/.test(e.key)) return; e.preventDefault();
        var n = (idx + (e.key === "ArrowRight" ? 1 : vs.length - 1)) % vs.length; set(n, true); $$(".sw", swBox)[n].focus();
      });
      box.addEventListener("pointerenter", function () { hover = true; });
      box.addEventListener("pointerleave", function () { hover = false; });
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(box);
      var every = +box.getAttribute("data-speed") || 3400;
      if (!reduce && box.getAttribute("data-auto") !== "false") box._timer = setInterval(function () {
        if (!doc.body.contains(box)) return clearInterval(box._timer);
        if (hover || !visible || doc.hidden || Date.now() - held < 9000) return;
        set((idx + 1) % vs.length, false);
      }, every);
    });
  }

  function initProduct(root) {
    $$("[data-pp]", root).forEach(function (pp) {
      if (pp._init) return; pp._init = true;
      var P; try { P = JSON.parse($("script[data-product-json]", pp).textContent); } catch (e) { return; }
      var form = $("form[data-product-form]", pp), idIn = form && form.elements.id, qIn = form && form.elements.quantity;
      var main = $(".pp-main", pp), thumbs = $(".thumbs", pp);
      var cur = P.variants.filter(function (v) { return v.id === +(idIn && idIn.value); })[0] || P.variants[0];
      var sel = cur.options.slice();
      function norm(u) { return String(u || "").replace(/^https?:/, "").split("?")[0]; }
      var i0 = main && $("img", main); if (i0) i0.setAttribute("data-src", norm((cur.featured_image && cur.featured_image.src) || P.featured_image));
      function show(src) {
        if (!src || !main) return;
        src = norm(src);
        var last = $("img:last-of-type", main); if (last && last.getAttribute("data-src") === src) return;
        var im = new Image(); im.src = src + "?width=1200"; im.setAttribute("data-src", src); im.alt = P.title;
        im.className = reduce || !last ? "" : "pour-in"; main.appendChild(im);
        if (last && !reduce) {
          requestAnimationFrame(function () { requestAnimationFrame(function () { im.classList.add("go"); }); });
          setTimeout(function () { $$("img", main).forEach(function (o) { if (o !== im) o.remove(); }); im.className = ""; }, 950);
        } else $$("img", main).forEach(function (o) { if (o !== im) o.remove(); });
        $$("button", thumbs).forEach(function (b) { b.classList.toggle("on", norm(b.getAttribute("data-src")) === src); });
      }
      if (thumbs) thumbs.addEventListener("click", function (e) { var b = e.target.closest("button"); if (b) show(b.getAttribute("data-src")); });
      function find() { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }
      function sync(first) {
        var v = find();
        $$("[data-opt]", pp).forEach(function (b) {
          var i = +b.getAttribute("data-opt"); b.setAttribute("aria-checked", b.getAttribute("data-value") === sel[i] ? "true" : "false");
        });
        $$("[data-opt-name]", pp).forEach(function (el) { el.textContent = sel[+el.getAttribute("data-opt-name")] + (v && !v.available ? " — " + S.soldOut : ""); });
        $$("[data-buy]").forEach(function (b) {
          b.disabled = !v || !v.available;
          if (b.hasAttribute("data-label-add")) b.textContent = !v ? S.unavailable : v.available ? b.getAttribute("data-label-add") : S.soldOut;
        });
        var note = $(".oos-note", pp); if (note) note.hidden = !!(v && v.available);
        if (!v) return;
        cur = v; if (idIn) idIn.value = v.id;
        var q = qIn ? +qIn.value || 1 : 1;
        $$("[data-price]", pp).forEach(function (el) { el.textContent = money(v.price); });
        $$("[data-compare]", pp).forEach(function (el) { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ""; el.hidden = !(v.compare_at_price > v.price); });
        $$("[data-off]", pp).forEach(function (el) { var o = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0; el.textContent = o ? "-" + o + "%" : ""; el.hidden = !o; });
        $$("[data-sticky-price]").forEach(function (el) { el.textContent = money(v.price * q); });
        if (!first && v.featured_image) show(v.featured_image.src);
        if (!first && history.replaceState) history.replaceState(null, "", location.pathname + "?variant=" + v.id);
        pp.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant: v } }));
      }
      pp.addEventListener("click", function (e) {
        var b = e.target.closest("[data-opt]");
        if (b) { sel[+b.getAttribute("data-opt")] = b.getAttribute("data-value"); if (b.classList.contains("sw")) { b.classList.remove("ripple"); void b.offsetWidth; b.classList.add("ripple"); } sync(); return; }
        var s = e.target.closest("[data-qty-step]");
        if (s && qIn) { qIn.value = Math.max(1, Math.min(99, (+qIn.value || 1) + +s.getAttribute("data-qty-step"))); $$("[data-qty-out]", pp).forEach(function (o) { o.textContent = qIn.value; }); sync(true); }
      });
      $$("select[data-opt-select]", pp).forEach(function (s) { s.addEventListener("change", function () { sel[+s.getAttribute("data-opt-select")] = s.value; sync(); }); });
      show((cur.featured_image && cur.featured_image.src) || P.featured_image); sync(true);
    });
  }

  function initCollection(root) {
    $$(".seg", root).forEach(function (seg) {
      var thumb = $(".thumb", seg), on = $('[aria-current="page"], [aria-pressed="true"]', seg);
      function move() { if (thumb && on) { thumb.style.left = on.offsetLeft + "px"; thumb.style.width = on.offsetWidth + "px"; } else if (thumb) thumb.style.width = 0; }
      move(); addEventListener("resize", move); if (doc.fonts) doc.fonts.ready.then(move);
      if (on && on.scrollIntoView && seg.scrollWidth > seg.clientWidth) seg.scrollLeft = on.offsetLeft - 20;
    });
    $$("select[data-sort-by]", root).forEach(function (s) {
      s.addEventListener("change", function () { var u = new URL(location.href); u.searchParams.set("sort_by", s.value); u.searchParams.delete("page"); location.href = u.toString(); });
    });
  }

  function initWa(root) {
    $$("[data-wa]", root).forEach(function (a) {
      if (!T.whatsapp) return;
      var msg = a.getAttribute("data-wa") || "";
      a.href = "https://wa.me/" + T.whatsapp + (msg ? "?text=" + encodeURIComponent(msg) : "");
      a.target = "_blank"; a.rel = "noopener";
    });
  }

  function init(root) { initCards(root); initPour(root); initProduct(root); initCollection(root); initWa(root); }
  init(doc);

  /* theme editor: sections are re-rendered without a page load */
  doc.addEventListener("shopify:section:load", function (e) {
    var s = e.target;
    $$("[data-reveal]", s).forEach(function (el) { el.classList.add("in"); });
    $$("[data-bar]", s).forEach(function (el) { el.style.setProperty("--w", el.getAttribute("data-bar") + "%"); });
    init(s);
  });
  doc.addEventListener("shopify:block:select", function (e) {
    var d = e.target.closest("details"); if (d) d.open = true;
  });
  window.ElipaTheme = { money: money, refreshCart: refreshCart, openCart: setOpen, addToCart: addToCart };
})();

/* ---------- product urgency: daily countdown + real stock (runs before motion.js) ---------- */
(function () {
  "use strict";
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function initUrgency(root) {
    // daily mode: real deadline = tonight 23:59:59 (customer's local time)
    $$("[data-cd-daily]", root).forEach(function (el) {
      var d = new Date(); d.setHours(23, 59, 59, 0);
      el.setAttribute("data-countdown", d.toISOString());
    });
    // invalid or past date: hide the block (never show a fake or expired timer)
    $$(".pp-cd[data-countdown]", root).forEach(function (el) {
      var t = new Date(el.getAttribute("data-countdown")).getTime();
      if (isNaN(t) || t <= Date.now()) el.hidden = true;
    });
    $$("[data-stock]", root).forEach(function (box) {
      if (box._init) return; box._init = true;
      var map = {}; try { map = JSON.parse(box.querySelector("[data-stock-json]").textContent); } catch (e) {}
      var max = +box.getAttribute("data-threshold") || 10, text = box.querySelector("[data-stock-text]"), bar = box.querySelector("[data-stock-bar]");
      function show(id) {
        var q = map[String(id)];
        if (q === null || q === undefined) {
          var u = box.getAttribute("data-untracked");
          box.hidden = !u; if (!u) return;
          text.textContent = u; bar.hidden = true; box.classList.remove("is-low"); return;
        }
        if (q <= 0 || q > max) { box.hidden = true; return; }
        box.hidden = false; bar.hidden = false;
        text.textContent = q === 1 ? box.getAttribute("data-one") : box.getAttribute("data-low").replace("[qty]", q);
        box.classList.toggle("is-low", q <= Math.max(2, Math.round(max / 3)));
        var i = bar.firstElementChild; i.style.width = "0%";
        requestAnimationFrame(function () { requestAnimationFrame(function () { i.style.width = Math.max(8, q / max * 100) + "%"; }); });
      }
      var form = document.getElementById("product-form");
      show(form && form.elements.id ? form.elements.id.value : Object.keys(map)[0]);
      document.addEventListener("variant:change", function (e) { if (e.detail && e.detail.variant) show(e.detail.variant.id); });
    });
  }
  initUrgency(document);
  document.addEventListener("shopify:section:load", function (e) { initUrgency(e.target); });
})();
